import { NgModule, provideZonelessChangeDetection } from '@angular/core';
import { AppComponent } from './app.component';
import { BuildModule } from './build.module';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Top-level, production application module
 */

@NgModule({
	imports: [BuildModule],
	bootstrap: [AppComponent],
	providers: [provideZonelessChangeDetection()]
})
export class AppModule {

}
